"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NorthsElegyAbilityHandler = exports.NorthsElegyActorAbilityFactory = exports.NorthsElegyAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class NorthsElegyAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.NorthsElegy;
        this.__typeName = "NorthsElegy";
    }
}
exports.NorthsElegyAbilityArgs = NorthsElegyAbilityArgs;
let NorthsElegyActorAbilityFactory = class NorthsElegyActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("NorthsElegy", "AllAllies", 3);
    }
};
NorthsElegyActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("NorthsElegy")
], NorthsElegyActorAbilityFactory);
exports.NorthsElegyActorAbilityFactory = NorthsElegyActorAbilityFactory;
let NorthsElegyAbilityHandler = class NorthsElegyAbilityHandler {
    init(sequence, container, actorId) {
        const temporaryHp = Math.round(0.5 * container.getMaxAttributeScore(actorId, enums_1.AttributeType.Focus));
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.PassiveBuffEffectArgs("North's Elegy", "Increases all allies hit points by 25% of focus", new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Health, temporaryHp)),
            onApplied: sequence => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(actorId, "head", "front"), 
                // TODO: use a different animation (maybe some music notes?)
                "BeamFromTheHeavens"));
            },
            supernatural: true,
        });
    }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.removeDebuffs({
                    sequence: sequence.pushSequence("parallel"),
                    removerId: ability.invokerId,
                    targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                        .map(allyId => ({
                        targetId: allyId,
                        includeSupernatural: false,
                        onDebuffsRemoved: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "chest", "front"), "DivineHealingWinds", false))
                    })),
                });
            }
        });
    }
};
NorthsElegyAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.NorthsElegy)
], NorthsElegyAbilityHandler);
exports.NorthsElegyAbilityHandler = NorthsElegyAbilityHandler;
